export const getDisplayName = Component => {
    try {
        return Component.displayName || Component.name || Component.constructor.name || `Component`;
    } catch (e) {
        return `Component`;
    }
};
